import React from 'react'
import agent from '../agent'
import Loading from './widgets/Loading'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
    TRADE_DETAIL_PAGE_LOADED,
    TRADE_DETAIL_PAGE_UNLOADED
} from '../constants/actionTypes'
import dateHelper from '../util/dateFormatter'
import numberHelper from '../util/numberFormatter'

const formatPrice = (price, trade_symbol) => {
    if (trade_symbol === 'ETHSPNC' || trade_symbol === 'BTCSPNC') {
        return numberHelper.Formatter.toDecimalTrim9(price) + ' SPNC'
    } else if (trade_symbol === 'SPNCETH') {
        return numberHelper.Formatter.toDecimalTrim9(price) + ' ETH'
    } else if (trade_symbol === 'SPNCBTC') {
        return numberHelper.Formatter.toDecimalTrim9(price) + ' BTC'
    } else {
        return numberHelper.Formatter.toCurrency(price) + ' USD'
    }
}
const formatFee = (fee, trade_symbol) => {
    if (trade_symbol === 'ETHSPNC') {
        return numberHelper.Formatter.toDecimalTrim9(fee) + ' ETH'
    } else if (trade_symbol === 'BTCSPNC') {
        return numberHelper.Formatter.toDecimalTrim9(fee) + ' BTC'
    } else if (trade_symbol === 'SPNCETH') {
        return numberHelper.Formatter.toDecimalTrim9(fee) + ' ETH'
    } else if (trade_symbol === 'SPNCBTC') {
        return numberHelper.Formatter.toDecimalTrim9(fee) + ' BTC'
    } else {
        return numberHelper.Formatter.toCurrency(fee) + ' USD'
    }
}

const mapStateToProps = state => ({
    ...state.trade,
    currentUser: state.common.currentUser
});

const mapDispatchToProps = dispatch => ({
    onLoad: payload =>
        dispatch({ type: TRADE_DETAIL_PAGE_LOADED, payload }),
    onUnload: () =>
        dispatch({ type: TRADE_DETAIL_PAGE_UNLOADED })
});

class TradeDetail extends React.Component {
    componentWillMount() {
        this.props.onLoad(
            agent.Trades.detail(this.props.match.params.key)
        );
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    renderMatchedOrders = () => {
        if (this.props.order.matched_orders) {
            return (
                <div className="infoPair">
                    <label > match orders :</label>
                    {this.props.order.matched_orders.map(item => {
                        return (
                            <label key={item.key}>{numberHelper.Formatter.toDecimal(item.amount)} {this.props.order.symbol.replace('BKN', 'SPNC')} @ {formatPrice(item.unit_price, this.props.order.trade_symbol)}</label>
                        )
                    })}
                </div>
            )
        }
    }
    render() {
        if (!this.props.order) {
            return (
                <Loading />
            )
        }
        const order = this.props.order
        const totalPrice = this.props.order.amount * this.props.order.unit_price
        const totalSettleAmount = this.props.order.matched_orders ?
            this.props.order.matched_orders.reduce((total, item) => total + (item.amount * item.unit_price), 0) :
            this.props.order.actual_amount_closed * this.props.order.actual_price_closed
        const trade_symbol = this.props.order.trade_symbol
        return (
            <div class='pane'>
                <Link className="crumb" to={`/trades`}>&laquo; back to trades</Link>

                <h1>Trade Detail</h1>
                <div className="infoGroup">
                    <div className="infoPair">
                        <label>Key:</label> <span>{order.key}</span>
                    </div>
                    <div className="infoPair">
                        <label>Time:</label> <span>{dateHelper.Formatter.toLocalString(order.created)}</span>
                    </div>
                    <div className="infoPair">
                        <label>status:</label> <span>{order.status}</span>
                    </div>
                    <div className="infoPair">
                        <label>type:</label> <span>{order.type}</span>
                    </div>
                    <div className="infoPair">
                        <label>unit price:</label> <span>{order.trade_symbol.replace('BKN', 'SPNC')} @ {formatPrice(order.unit_price, trade_symbol)}</span>
                    </div>
                    <div className="infoPair">
                        <label>amount:</label> <span>{numberHelper.Formatter.toDecimal(order.amount)} {order.symbol.replace('BKN', 'SPNC')}</span>
                    </div>
                    <div className="infoPair">
                        <label>total price:</label> <span>{formatPrice(totalPrice, trade_symbol)}</span>
                    </div>
                    <div className="infoPair">
                        <label>fee:</label> <span>{formatFee(order.fee, trade_symbol)}</span>
                    </div>
                    <div className="infoPair">
                        <label>settle price:</label><span>{formatPrice(totalSettleAmount, trade_symbol)}  </span>
                        <em>({numberHelper.Formatter.toDecimal(this.props.order.actual_amount_closed)} {this.props.order.symbol.replace('BKN', 'SPNC')} @ avg {formatPrice(totalSettleAmount / this.props.order.actual_amount_closed, trade_symbol)})</em>
                    </div>
                    {this.renderMatchedOrders()}
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TradeDetail);



// WEBPACK FOOTER //
// ./src/components/TradeDetail.js